// Built @Wed, 27 Dec 2023 03:56:16 GMT
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
var ENTRIES = [];
var MAX_COUNT = 30;
function findPerformanceInfo(url) {
  var ret = {};
  try {
    url = url.replace(/^http:|^https:/, "");
    var p = ENTRIES || [];
    var _loop = function _loop2(i2) {
      var name = p[i2].name.replace(/^http:|^https:/, "");
      if (name === url) {
        ["domainLookupEnd", "domainLookupStart", "startTime", "requestStart", "responseEnd", "responseStart", "connectStart", "connectEnd", "fetchStart"].map(function(item) {
          ret[item] = Math.round(p[i2][item]);
        });
        ret.url = p[i2].name;
        ret.duration = Math.round(p[i2].duration);
        ret.domainDuration = ret.domainLookupEnd - ret.domainLookupStart;
        ret.connectDuration = ret.connectEnd - ret.connectStart;
        return "break";
      }
    };
    for (var i = p.length - 1; i >= 0; i--) {
      var _ret = _loop(i);
      if (_ret === "break")
        break;
    }
    return ret;
  } catch (e) {
    return ret;
  }
}
function addPerformaceObserver() {
  try {
    var perfObserver = new window.PerformanceObserver(function(list) {
      var entries = list.getEntriesByType("resource");
      if (ENTRIES.length > MAX_COUNT) {
        ENTRIES.splice(0, ENTRIES.length - MAX_COUNT);
      }
      for (var i = 0; i < entries.length; i++) {
        ENTRIES.push(entries[i]);
      }
    });
    perfObserver.observe({
      entryTypes: ["resource"]
    });
  } catch (e) {
    console.warn("PerformanceObserver not support", e);
  }
}
typeof window !== "undefined" && addPerformaceObserver();
export {
  findPerformanceInfo
};
